import React from 'react'
import PurchaseSummary from './PurchaseSummary'

export default function OpenPurchaseSummary() {
    return (
        <PurchaseSummary xState={'OPEN'} />
    )
}
